
import Vue from "vue";

export default Vue.extend({
  props: {
    contentDivider: {
      type: Boolean,
      default: false,
    },
  },
});
